var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showWarning)?_c('v-alert',{attrs:{"text":"","outlined":"","color":"deep-orange"}},[_c('p',{key:_vm.countdownMessageKey},[_vm._v(_vm._s(_vm.countdownMessage))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }